
import { DELETE_API, GET_API, PATCH_API, POST_API, PUT_API } from '../../Functionalities/APIs'

export const ManageSection = async (e, data, keyword, params) => {
    // e.preventDefault()
    let function_name = "section";
    // void 0
    const path = "/items/sections/";
    // void 0

    if (keyword == "get") {
        // void 0

        let result = GET_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "delete") {
        // void 0

        let result = DELETE_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }

    if (keyword == "add") {
      var fdata = new FormData();

      if(data.section_type==="ADS"){
        fdata.append("url_link", data.url_link);  
      }
      fdata.append("name", data.name);
      fdata.append("section_type", data.section_type);
      fdata.append("object_type", data.object_type);
      fdata.append("image_type", data.image_type);
      fdata.append("priority", 15);
      fdata.append("slot", data.slot || "NONE");
      if (data.section_type === "SALE" && data.franchise_id) {
        fdata.append("franchise_id", data.franchise_id);
      }
      // Blank means always on, which is how every existing section behaves.
      fdata.append("visible_from", data.visible_from ?? "");
      fdata.append("visible_to", data.visible_to ?? "");

      // BANNER = 0, 'BANNER'
      // SQUARE_BANNER = 1, 'SQUARE_BANNER'
      // REGULAR_IMAGE = 2, 'REGULAR_IMAGE'
      // for (let i = 0; i < data.images.length; i++) {
        if(data.icon){
          // void 0
          fdata.append("icon", data.icon);
        }
      // }
      if (data.section_type==="REGULAR")
        // void 0
          fdata.append("branch_lst", JSON.stringify(data.ids) );
      if (data.section_type==="OFFER"){
          // void 0
          fdata.append("offer_id", JSON.stringify(data.ids) );
          // fdata.append("item_id", JSON.stringify([data.product]));
      }
      
      // for (var pair of fdata.entries()) {
      //   void 0
      // }
      
      let result = POST_API(fdata, "", path);
  
      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }
    if (keyword == "update") {

      // void 0
      var fdata = new FormData();
      fdata.append("id", data.id);
      fdata.append("name", data.name);
      fdata.append("keword", 'section');
      if (data.slot) fdata.append("slot", data.slot);
      fdata.append("visible_from", data.visible_from ?? "");
      fdata.append("visible_to", data.visible_to ?? "");

      // fdata.append("section_type", data.section_type);
      // fdata.append("object_type", data.object_type);
      // for (let i = 0; i < data.images.length; i++) {
      if(data.icon){
        // void 0
        fdata.append("icon", data.icon);
      }
      if(data.section_type==="ADS"){
        // void 0
        fdata.append("url_link", data.url_link);  
      }
      // }
      // if (data.section_type==="REGULAR")
      //     fdata.append("branch_lst", JSON.stringify([data.branch]) );
      // if (data.section_type==="OFFER"){
      //     fdata.append("offer_id", JSON.stringify([data.branch]) );
      //     // fdata.append("item_id", JSON.stringify([data.product]));
      // }
          
      
      let result = PUT_API(fdata, "", path);
  
      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }

    

    if (keyword == "add_branch" || keyword == "remove_branch") {
      // void 0
      var fdata = new FormData();
      fdata.append("id", data.id);
      fdata.append("keyword", keyword);
      keyword=="add_branch"?
        fdata.append("branch_list", JSON.stringify( data.offer_id))
      :
        fdata.append("branch_list", JSON.stringify( [data.offer_id]))

      // fdata.append("branch_list", JSON.stringify( [data.offer_id]));
      

      let result = PUT_API(fdata, "", path);

      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }
    if (keyword == "add_offer" || keyword == "remove_offer") {
      // void 0
      var fdata = new FormData();
      fdata.append("id", data.id);
      fdata.append("keyword", keyword);
      fdata.append("offer_list", JSON.stringify( data.offer_id));

      let result = PUT_API(fdata, "", path);

      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }
    if (keyword == "patch" ) {
      // void 0
      var fdata = new FormData();
      fdata.append("keyword", "update_order");
      fdata.append("order_lst", JSON.stringify( data.order_list));

      let result = PATCH_API(fdata, "", path);

      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }
};






// if (keyword == "remove_branch") {
//   void 0

//   var fdata = new FormData();
//   fdata.append("id", data.id);
//   fdata.append("keyword", 'remove_branch');
//   fdata.append("branch_list", JSON.stringify( [data.offer_id]));

//   let result = PUT_API(fdata, "", path);

//   return await result.then((result) => {
//     // void 0
//     if (result) {
//       // void 0
//       return result;
//     } else {
//       return 0;
//     }
//   });
// }

// if (keyword == "add_offer") {
//   void 0

//   var fdata = new FormData();
//   fdata.append("id", data.id);
//   fdata.append("keyword", 'add_offer');
//   fdata.append("offer_list", JSON.stringify( data.offer_id));

//   let result = PUT_API(fdata, "", path);

//   return await result.then((result) => {
//     // void 0
//     if (result) {
//       // void 0
//       return result;
//     } else {
//       return 0;
//     }
//   });
// }
// if (keyword == "remove_offer") {
//   void 0

//   var fdata = new FormData();
//   fdata.append("id", data.id);
//   fdata.append("keyword", 'remove_offer');
//   fdata.append("offer_list", JSON.stringify( data.offer_id));

//   let result = PUT_API(fdata, "", path);

//   return await result.then((result) => {
//     // void 0
//     if (result) {
//       // void 0
//       return result;
//     } else {
//       return 0;
//     }
//   });
// }

// if (keyword == "add_item" || keyword == "remove_item") {
//   void 0
//   var fdata = new FormData();
//   fdata.append("id", data.id);
//   fdata.append("keyword", 'add_item');
//   // fdata.append("item_list", JSON.stringify( data.offer_id));
//   fdata.append("offer_list", JSON.stringify( data.offer_id));

//   let result = PUT_API(fdata, "", path);

//   return await result.then((result) => {
//     // void 0
//     if (result) {
//       // void 0
//       return result;
//     } else {
//       return 0;
//     }
//   });
// }
// if (keyword == "remove_item") {
//   void 0
//   var fdata = new FormData();
//   fdata.append("id", data.id);
//   fdata.append("keyword", 'remove_item');
//   fdata.append("item_list", JSON.stringify( [data.offer_id]));

//   let result = PUT_API(fdata, "", path);

//   return await result.then((result) => {
//     // void 0
//     if (result) {
//       // void 0
//       return result;
//     } else {
//       return 0;
//     }
//   });
// }